module.exports = __webpack_public_path__ + "merge_left.svg?c48131e0c321569193f96b09410dc842";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/merge_left.svg
// module id = 177
// module chunks = 0